import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './create_basics.less'
import { getI18n } from 'client/i18n'

import TextBox from 'components/common/text_box'
import DateInputBox from 'components/common/date_input_box'
import MoneyTextBox from 'components/common/money_text_box'
import Separator from 'components/common/separator'
import Checkbox from 'components/common/checkbox'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import { MONEY_POOLS_MAX_DAYS } from 'shared/shared_consts'

export const I18N_CONTEXT = 'components/pages/create/pool_basics'
const i18n = getI18n(I18N_CONTEXT)
// TODO: change i18nTemp back to i18n after translations are merged
const i18nTemp = getI18n('components/pages/crowdfunding/pool_basics')

class PoolBasics extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    untouchAll: PropTypes.func.isRequired,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    countryCode: PropTypes.string.isRequired,
    shouldAutoFocus: PropTypes.bool,
  }

  UNSAFE_componentWillMount = () => {
    this.props.untouchAll()
  }

  componentDidMount() {
    sendEnsightenEvent('MoneyPoolStart')
  }

  render() {
    const {
      fields: { poolName, goalAmount, endDate, shareProgress },
      anyInactiveFieldsTouchedWithError,
    } = this.props

    return (
      <form onSubmit={this.props.handleSubmit}>
        <div styleName="title">{i18n('title')}</div>
        <div styleName="subtitle">{i18n('subtitle')}</div>
        <div>
          <div styleName="textbox-wrapper">
            <TextBox
              title={i18n('pool_name_title')}
              dataNemo="your-pool-name"
              autoFocus={this.props.shouldAutoFocus}
              {...poolName}
            />
          </div>
          <div styleName="textbox-wrapper">
            <MoneyTextBox
              title={i18n('goal_amount_title')}
              dataNemo="goal-amount"
              disableCents={false}
              {...goalAmount}
            />
          </div>
          <div styleName="textbox-wrapper">
            <DateInputBox
              // TODO update to i18n when translation are merged
              title={i18nTemp('end_date_title', {
                maxDays: MONEY_POOLS_MAX_DAYS,
              })}
              dataNemo="date-pool-ends"
              {...endDate}
            />
          </div>
        </div>
        <Separator type="dotted" />
        <div styleName="checkbox-wrapper">
          <Checkbox
            data-pa-click="shareProgress"
            dataNemo="show-amount-checkbox"
            name="share"
            label={i18n('share_your_progress')}
            onChange={shareProgress.onChange}
            value={!!shareProgress.value}
          />
        </div>
        <button
          data-nemo="create-basics-next"
          data-pa-click="next"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          styleName="next-button"
        >
          {i18n('next')}
        </button>
      </form>
    )
  }
}

export default cssModules(PoolBasics, styles)
